export default __webpack_public_path__ + "static/media/gridImage8.fc9b84e1.jpg";